import { Box, Typography, IconButton } from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // Para TikTok fallback

const SocialMedia = ({ profile }) => {
  const getSocialLink = (id, username) => {
    if (!username) return null;
    if (username.startsWith('http')) return username;
    
    // Remove @ if user included it
    const cleanUsername = username.startsWith('@') ? username.slice(1) : username;

    const baseUrls = {
      instagram: 'https://instagram.com/',
      facebook: 'https://facebook.com/',
      tiktok: 'https://tiktok.com/@',
      youtube: 'https://youtube.com/@',
      twitter: 'https://x.com/',
      linkedin: 'https://linkedin.com/in/'
    };

    return baseUrls[id] ? `${baseUrls[id]}${cleanUsername}` : `https://${username}`;
  };

  const themeColor = '#0E2465';
  const inactiveColor = '#CBD5E1';

  const redes = [
    { key: 'instagram', icon: <InstagramIcon />, url: getSocialLink('instagram', profile?.redes?.instagram) },
    { key: 'facebook', icon: <FacebookIcon />, url: getSocialLink('facebook', profile?.redes?.facebook) },
    { key: 'tiktok', icon: <MusicNoteIcon />, url: getSocialLink('tiktok', profile?.redes?.tiktok) },
    { key: 'youtube', icon: <YouTubeIcon />, url: getSocialLink('youtube', profile?.redes?.youtube) },
    { key: 'twitter', icon: <XIcon />, url: getSocialLink('twitter', profile?.redes?.twitter) },
    { key: 'linkedin', icon: <LinkedInIcon />, url: getSocialLink('linkedin', profile?.redes?.linkedin) },
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: themeColor, mb: 0.5 }}>
        Redes sociales
      </Typography>
      <Typography variant="body2" sx={{ color: '#737791', display: 'block', mb: 3 }}>
        Sigue el trabajo de {profile?.perfil?.rol || 'el proveedor'} en sus redes
      </Typography>

      <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
        {redes.map((red) => {
          const isActive = !!red.url;
          return (
            <IconButton
              key={red.key}
              component={isActive ? "a" : "div"}
              href={isActive ? red.url : undefined}
              target={isActive ? "_blank" : undefined}
              sx={{
                bgcolor: 'white',
                boxShadow: '0px 4px 10px rgba(0,0,0,0.05)',
                width: 44,
                height: 44,
                color: isActive ? themeColor : inactiveColor,
                '&:hover': isActive ? {
                  bgcolor: '#f5f5f5',
                  transform: 'translateY(-2px)',
                  color: themeColor,
                } : {
                  bgcolor: 'white',
                },
                transition: 'all 0.2s',
                cursor: isActive ? 'pointer' : 'default',
                opacity: isActive ? 1 : 0.5,
              }}
            >
              {red.icon}
            </IconButton>
          );
        })}
      </Box>
    </Box>
  );
};

export default SocialMedia;
